<div class="notFound_wrapper">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <img src="../../../assets/images/404.svg" alt="404">
                <h2>Whoops! You are not authorized to access this page.</h2>
                <p>If you believe this is an error, please get in touch with our&nbsp;support&nbsp;center.</p>
            </div>
        </div>
    </div>
</div>
